import { render, staticRenderFns } from "./edit.projects.page.vue?vue&type=template&id=d8aa150c&"
import script from "./edit.projects.page.vue?vue&type=script&lang=js&"
export * from "./edit.projects.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports